module.exports = __webpack_public_path__ + "img/icon_service@2x.27f6ed4b.png";